'use client';
import { CartDrawer as SharedCartDrawer } from '@repo/ui/src/components/Cart';
import MeaterCart from '@components/Cart';

export const CartDrawer = () => (
  <SharedCartDrawer>
    <MeaterCart />
  </SharedCartDrawer>
);
